export const getAuthHeaders = (businessId) => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
  try {
    // Prefer a token scoped to this business if stored with a namespaced key
    const namespacedKey = businessId ? `authToken:${businessId}` : null;
    const token = (namespacedKey && localStorage.getItem(namespacedKey)) || localStorage.getItem('authToken');
    if (token) headers['Authorization'] = `Bearer ${token}`;
    // Optionally pass business context header if backend supports it
    if (businessId) headers['X-Business-Id'] = String(businessId);
  } catch (e) {
    // ignore localStorage errors
  }
  return headers;
};

export default getAuthHeaders;
